export enum SitemapRoutePathsEnum {
  SITEMAP = 'sitemap',
}
